import React from 'react'
import { useTranslation } from 'react-i18next'

const LanguageSwitcher = () => {
  const { i18n } = useTranslation()
  const isAr = i18n.language === 'ar'

  const toggleLang = () => {
    i18n.changeLanguage(isAr ? 'en' : 'ar')
  }

  return (
    <button
      onClick={toggleLang}
      className="flex items-center gap-1 px-2.5 py-1.5 bg-white/5 border border-white/20 rounded-lg text-xs font-semibold text-gray-300 hover:text-purple-400 hover:border-purple-500/50 hover:bg-white/10 active:scale-[0.98] transition-all duration-200"
      aria-label="Switch language"
    >
      <span className={!isAr ? 'text-purple-400' : 'text-gray-500'}>EN</span>
      <span className="text-gray-600">|</span>
      <span className={isAr ? 'text-purple-400' : 'text-gray-500'}>AR</span>
    </button>
  )
}

export default LanguageSwitcher
